var render = function render(){var _vm=this,_c=_vm._self._c;return _c('active-button',{attrs:{"fa-icon":_vm.startStopIcon,"text":_vm.startStopText,"disabled":_vm.startStopDisabled,"type":_vm.startStopColor},on:{"click":function($event){return _vm.$emit('click')}}})
}
var staticRenderFns = []

export { render, staticRenderFns }